import React, { useContext } from 'react'
import { AppContext } from '@state/context'
import { closePanel } from '@state/actions/panelsActions'
import Button from '@components/Button'
import Heading from '@components/Heading'
import Divider from '@components/Divider'
import {
  PANELS,
  DIVIDER_SIZE,
  BUTTON_SIZE,
  HEADING_TYPE,
  TEXT_SIZES,
  LABELS,
} from '@helpers/constants'
import Text from '@components/Text'
import { Tabs, Tab } from '@components/Tabs'
import EditBookForm from './EditBookForm'
import EditSections from './EditSections'
import { setEditBookPanelStartOnTab } from '@state/actions/appActions'
import { useSingleBook } from '@hooks/useSingleBook'
import Loader from '@components/Loader'

const EditBookPanel = () => {
  const [state, dispatch] = useContext(AppContext)
  const {
    app: { editBookPanelStartOnTab, currentEditBookId },
  } = state
  const { book, isLoading } = useSingleBook(currentEditBookId)

  return (
    <>
      <div className='flex justify-end items-center'>
        <Button
          handleClick={() => {
            dispatch(setEditBookPanelStartOnTab(null))
            dispatch(closePanel(PANELS.EDIT_BOOK))
          }}
          size={BUTTON_SIZE.NO_PADDING}
          icon={'Close'}
        ></Button>
      </div>

      <Heading headingLevel={HEADING_TYPE.H2} size={TEXT_SIZES.XLARGE}>
        Om min bok
      </Heading>

      <Divider size={DIVIDER_SIZE.SMALL} />
      {isLoading ? (
        <Loader noMargin />
      ) : (
        <Tabs startOnTab={editBookPanelStartOnTab}>
          <Tab label={LABELS.EDIT_BOOK}>
            <EditBookForm book={book} />
          </Tab>

          <Tab label={LABELS.EDIT_SECTIONS}>
            <EditSections book={book} />
          </Tab>
        </Tabs>
      )}
    </>
  )
}

export default EditBookPanel
